/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useState } from 'react';

interface IUserDisableEnableButtonProps {
  isDeleted: boolean;
  onDisable: () => void;
  onEnable: () => void;
}

export const UserDisableEnableButton: FunctionComponent<IUserDisableEnableButtonProps> = ({
  isDeleted,
  onDisable,
  onEnable,
}) => {
  const [isActive, setIsActive] = useState(false);

  const toggle = useCallback(() => {
    setIsActive((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsActive(false);
  }, []);

  return (
    <div className={isActive ? 'dropdown opened' : 'dropdown'} style={{ marginRight: 'auto' }}>
      <div style={{ paddingLeft: '5px' }} onClick={toggle}>
        <a className={`btn btn-sm ${isDeleted ? 'green-bg' : 'red-bg'}`} data-popup="enable_popup">
          {isDeleted ? 'Enable' : 'Disable'}
        </a>
      </div>
      {isDeleted ? (
        <PopupMenu
          popupHeader="Enable User"
          popupMessage="You are about to enable a User. This will restore access to the user and they will be able to use the system again."
          confirmButtonText="Enable User"
          confirmButtonClassName="btn btn-md green-bg"
          onConfirm={onEnable}
          onClose={close}
        />
      ) : (
        <PopupMenu
          popupHeader="Disable User"
          popupMessage="You are about to disable a User. Before moving forward make sure you move all items and goals assigned to the user to new owners, and re-organize each Meeting the user is part of accordingly."
          confirmButtonText="Disable User"
          confirmButtonClassName="btn btn-md red-bg"
          onConfirm={onDisable}
          onClose={close}
        />
      )}
    </div>
  );
};

interface IPopupMenuProps {
  popupHeader: string;
  popupMessage: string;
  confirmButtonText: string;
  confirmButtonClassName: string;
  onConfirm: () => void;
  onClose: () => void;
}

const PopupMenu: FunctionComponent<IPopupMenuProps> = ({
  popupHeader,
  popupMessage,
  confirmButtonText,
  confirmButtonClassName,
  onConfirm,
  onClose,
}) => {
  return (
    <div className="dropdown-menu drop-up drop-down max-h320">
      <div className="mini-popup">
        <div className="mini-popup-header">
          {popupHeader}
          <span className="close_mini_popup" onClick={onClose}>
            ×
          </span>
        </div>
        <div className="mini-popup-body">
          <p className="ln mb-2 darkGray">{popupMessage}</p>
          <a className={`${confirmButtonClassName} white d-block jcc`} onClick={onConfirm}>
            {confirmButtonText}
          </a>
        </div>
      </div>
    </div>
  );
};
